var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBaseball = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Baseball-Bat-Ball--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Baseball Bat Ball Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 18.33a2.7 2.7 0 1 0 5.4 0 2.7 2.7 0 1 0 -5.4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89 19.87A1.08 1.08 0 1 0 0.36 21.4l2.29 2.28a1.08 1.08 0 1 0 1.53 -1.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52 16.94a0.5 0.5 0 0 0 -0.7 0L3.3 18.46a0.5 0.5 0 0 0 0 0.7l1.58 1.58a0.5 0.5 0 0 0 0.71 0l1.51 -1.51a0.47 0.47 0 0 0 0.15 -0.35 0.49 0.49 0 0 0 -0.15 -0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1a3.45 3.45 0 0 0 -5.14 0.3L6.5 15.16a0.5 0.5 0 0 0 0 0.67l1.68 1.68a0.51 0.51 0 0 0 0.68 0l13.8 -11.39A3.43 3.43 0 0 0 23 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBaseball);
export default ForwardRef;